export const PREVIEW_WIDGET_VERTICAL_PADDING = 50;
export const PREVIEW_WIDGET_VERTICAL_PADDING_MOBILE = 30;
export const DEFAULT_MOBILE_MIN_CARD_WIDTH = 155;
export const DEFAULT_MIN_CARD_WIDTH = 220;
